import React, { useEffect, useState } from "react";
import mammoth from "mammoth";

type DocumentViewerProps = {
  docUrl: string;
};

const DocumentViewer: React.FC<DocumentViewerProps> = ({ docUrl }) => {
  const [html, setHtml] = useState("");

  console.log("DocumentViewer Render");
  console.log("docUrl =", docUrl);

  
  useEffect(() => {
    const loadDocument = async () => {
      try {
        const response = await fetch(docUrl);
        console.log("bk test" , response.headers.get("content-type"));
        const arrayBuffer = await response.arrayBuffer();

        const result = await mammoth.convertToHtml({
          arrayBuffer,
        });

        setHtml(result.value);
      } catch (error) {
        console.error("Error loading document:", error);
      }
    };

    loadDocument();
  }, [docUrl]);

  return (
    <div
      className="document-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default DocumentViewer;
